// Angular
import { Component, OnInit } from '@angular/core';
// Layout
import { LayoutConfigService } from '../../../core/_base/layout';
// Object-Path
import * as objectPath from 'object-path';

@Component({
	selector: 'kt-footer',
	templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit {
	// Public properties
	today: number = Date.now();
	fluid: boolean;
	privacyPolicyUrl: string ='';
	tncUrl: string = '';
	disclaimerUrl: string = '';
	copyrightName : any = 'Loading';
	privacyPolicyFlag: boolean;
	tncFlag: boolean;
	disclaimerFlag: boolean;
	/**
	 * Component constructor
	 *
	 * @param layoutConfigService: LayouConfigService
	 */
	constructor(private layoutConfigService: LayoutConfigService) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		const config = this.layoutConfigService.getConfig();
		this.setWhiteLabelling();
		// footer width fluid
		this.fluid = objectPath.get(config, 'footer.self.width') === 'fluid';
	}

	setWhiteLabelling(){
		setTimeout(() => {
		  if(localStorage.getItem('copyrightName')){
			this.copyrightName = localStorage.getItem('copyrightName')
		  }
		  
		 
		 
		  if(localStorage.getItem('privacyPolicyUrl')){
			this.privacyPolicyFlag = true;
			this.privacyPolicyUrl = localStorage.getItem('privacyPolicyUrl')
		  }else{
			this.privacyPolicyFlag = false;
		  }
		  if(localStorage.getItem('tncUrl')){
			this.tncFlag = true;
			this.tncUrl = localStorage.getItem('tncUrl')
		  }else{
			this.tncFlag = false;
		  }
		  if(localStorage.getItem('disclaimerUrl')){
			this.disclaimerFlag = true;
			this.disclaimerUrl = localStorage.getItem('disclaimerUrl')
		  }else{
			this.disclaimerFlag = false;
		  }
		}, 500);
		
	}
	redirectToURL(url){
		window.open(url,  "_blank");
	  }
}
